import { AppBar, Box, Button, Toolbar, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useAppSelector } from "../../../hooks/redux";
import ProfileDropdown from "./ProfileDropdown";
import AdditionalInfo from "./AdditionalInfo";
import { PATHS } from "../../../constants";
import LogoIconSm from "../../components/icons/LogoIconSm";
import { NoLinkControllerPopUp } from "../../components/NoLinkControllerPopUp";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import {
  useCloseSessionMutation,
  useLazyGetActiveSessionQuery,
  useLazyIsValidTokenQuery,
  useStartSessionMutation,
  useUpdateLoginDataMutation,
} from "../../../middleware/usersApi";
import dayjs from "dayjs";
import { handleLogoutFromSystem } from "../../../helpers/siteHelper";
import { useAction } from "../../../hooks/actions";
import "./style.css";

const Header = () => {
  const { roleId } = useAppSelector((state) => state.users.info);
  const { token } = useAppSelector((state) => state.users);
  const { setAuthStep, logout } = useAction();
  const navigate = useNavigate();
  const [timer, setTimer] = useState(0);
  const [isValidTokenState, setIsValidTokenState] = useState(true);
  const { t } = useTranslation();
  const [getActiveSession] = useLazyGetActiveSessionQuery();
  const [startSession] = useStartSessionMutation();
  const [closeSession] = useCloseSessionMutation();
  const [isValidToken] = useLazyIsValidTokenQuery();
  const [updateLoginData] = useUpdateLoginDataMutation();

  useEffect(() => {
    if (!token) return;
    getActiveSession(token).then(({ data, error }) => {
      if (error) return;
      const startTime = data?.startTime;

      if (!startTime) startSession().then(() => {});
      else {
        const userTimezoneOffset = dayjs().utcOffset();
        const now = dayjs().subtract(userTimezoneOffset, "minutes");
        const target = dayjs(startTime);
        const differenceInSeconds = now.diff(target, "second");

        setTimer(differenceInSeconds);
      }
    });
  }, [token]);

  useEffect(() => {
    if (isValidTokenState === false) {
      alert("Вышла новая версия требуется войти в систему заново");
      handleLogoutFromSystem(setAuthStep, logout);
    }
  }, [isValidTokenState]);

  function endWork() {
    closeSession({}).then(() => {
      handleLogoutFromSystem(setAuthStep, logout);
    });
  }

  useEffect(() => {
    let intervalId;

    updateLoginData();

    intervalId = setInterval(() => {
      updateLoginData();
    }, 1000);

    return () => {
      if (intervalId) {
        clearInterval(intervalId);
      }
    };
  }, []);

  useEffect(() => {
    let interval = null;

    interval = setInterval(() => {
      setTimer((prevTimer) => prevTimer + 1);
    }, 1000);

    return () => {
      interval && clearInterval(interval);
    };
  }, [timer]);

  const formatTime = (seconds) => {
    const hours = Math.floor(seconds / 3600);
    const minutes = Math.floor((seconds % 3600) / 60);
    const secs = seconds % 60;

    return [
      hours.toString().padStart(2, "0"),
      minutes.toString().padStart(2, "0"),
      secs.toString().padStart(2, "0"),
    ].join(":");
  };

  useEffect(() => {
    if (!token) return;

    const promises = Promise.all([isValidToken()]);

    promises.then(([tokenData]) => {
      setIsValidTokenState(tokenData.data);
    });
  }, [token]);
  return (
    <AppBar className="app_header" position="absolute">
      <Toolbar
        sx={{
          minHeight: "var(--heighHeader) !important",
          display: "flex",
          justifyContent: "flex-end",
          backgroundColor: "var(--white)",
          padding: "12px 32px !important",
        }}
      >
        <Box
          className="header-logo-container"
          onClick={() => (roleId !== 4 ? navigate(PATHS.OBJECTS_ON_MAP) : navigate(PATHS.LIST_TASKS))}
        >
          <LogoIconSm />
        </Box>
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            width: "100%",
          }}
        >
          <AdditionalInfo />

          <Box className="header-navbar-dropdown">
            <Button className="btn btn-primary-fill" variant="outlined" onClick={endWork}>
              <Typography sx={{ width: "auto", textAlign: "left" }}>{formatTime(timer)}</Typography>
              {t("Завершить смену")}
            </Button>
            <NoLinkControllerPopUp />
            <ProfileDropdown />
          </Box>
        </Box>
      </Toolbar>
    </AppBar>
  );
};

export default Header;
